import React from 'react';

export default function Footer() {
  return (
    <footer className="bg-primary text-white">
      <div className="w-full px-1 py-4">
        <div className="flex flex-col items-center justify-center space-y-1">
            <div className="text-sm text-white flex flex-wrap justify-center gap-x-4 gap-y-1">
              <a href="/privacy" className="hover:text-secondary-light transition-colors">
                Privacy Policy
              </a>
              <span>|</span>
              <a href="/cookies" className="hover:text-secondary-light transition-colors">
                Cookie Policy
              </a>
              <span>|</span>
              <a href="/terms" className="hover:text-secondary-light transition-colors">
                Terms of Service
              </a>
              <span>|</span>
              <button
                onClick={() => {
                  localStorage.removeItem('cookie_consent_given');
                  window.location.reload();
                }}
                className="hover:text-secondary-light transition-colors underline"
              >
                Cookie Preferences
              </button>
              <span>|</span>
              <a href="/feedback" className="hover:text-secondary-light transition-colors">
                Feedback
              </a>
              <span>|</span>
              <span>© {new Date().getFullYear()} Local Artist Fairs. All rights reserved.</span>
              <span>|</span>
              <span className="text-secondary-light">
                Created by{' '}
                <a
                  href="https://wordenpondconsulting.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="underline hover:text-secondary transition-colors"
                >
                  Worden Pond Consulting
                </a>
              </span>
            </div>
        </div>
      </div>
    </footer>
  );
}